module.exports = __webpack_public_path__ + "media/bootstrap-icons/brightness-low-2cbbedcb.svg";